import { render, staticRenderFns } from "./feedback_vote.vue?vue&type=template&id=1435f4d3&"
import script from "./feedback_vote.vue?vue&type=script&lang=js&"
export * from "./feedback_vote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports